module.exports = __webpack_public_path__ + "static/media/como-25.9936f09b.jpg";